export default __webpack_public_path__ + "static/media/draw.b0560336.png";